/*
 *  Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import { Helmet } from "react-helmet-async";
import { gaSet } from "@/src/services/googleAnalyticsService";

const TermsOfServiceLawFirmPageMeta = () => {
  const title = "AGB Legalbird Rechtsanwälte Rechtsanwalts GmbH | Legalbird";
  gaSet({ title: title });

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content="Lesen Sie hier die allgemeinen Geschäftsbedingungen der Legalbird Rechtsanwälte Rechtsanwalts GmbH" />
      <meta name="keywords" content="AGB, Allgemeine Geschäftsbedingungen Kanzlei" />
      <meta name="robots" content="index,follow" />
      <meta property="og:title" content={title} />
      <meta property="og:locale" content="de_DE" />
      <meta property="og:type" content="website" />
      <meta property="og:description" content="Lesen Sie hier die allgemeinen Geschäftsbedingungen der Legalbird Rechtsanwälte Rechtsanwalts GmbH" />
    </Helmet>
  );
};

export default TermsOfServiceLawFirmPageMeta;
